import React, { useState } from "react";

import { useDispatch } from "react-redux";
import { UpgradePlan } from "../../apis/api/MembershipApi";
import Cookies from "js-cookie";
import { toast } from 'react-toastify';
import { motion } from "framer-motion";
import MembershipUpgradeModal from "../../components/MembershipUpgradeModal";

const MembershipPlan = ({ plan, allPlans }) => {

  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const company_id = Cookies.get("company_id");
  const userID = Cookies.get("userID");
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = plan.description.replace(/&nbsp;/g, "");
  const descriptionListItems = Array.from(tempDiv.querySelectorAll("li")).map(
    (li, index) => (
      <li
        key={`desc-${index}`}
        className="mp-feature"
        dangerouslySetInnerHTML={{ __html: li.innerHTML }}
      />
    )
  );

  const allItems = [
    ...descriptionListItems,
  ];

  // Find current plan from allPlans
  const currentPlan = allPlans?.find(p => p.current_plan === 1) || plan;

  const handleUpgradeClick = () => {
    setShowModal(true);
  };

  return (
    <>
      <motion.article
        className={`mp-card ${plan.current_plan === 1 ? "mp-card--active" : ""}`}
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.34, ease: [0.22, 0.68, 0, 1.2] }}
        whileHover={{ y: -6 }}
      >
        <div className="mp-head">
          <h3 className="mp-name">{plan.membership_name}</h3>
          <div className="mp-price-row">
            <span className="mp-price">${plan.fees}</span>
            <span className="mp-duration">{plan.duration_in_months} months</span>
          </div>
        </div>

        <div className="mp-body">
          <ul className="mp-features">
            {allItems.slice(0, 4)}
            {visible && <>{allItems.slice(4)}</>}
          </ul>

          {allItems.length > 4 && (
            <button className="mp-link" onClick={() => setVisible(!visible)}>
              {visible ? "Hide details" : "View more"}
            </button>
          )}
        </div>

        <div className="mp-foot">
          {plan.current_plan === 0 ? (
            <button className="mp-btn" onClick={handleUpgradeClick}>
              {plan.plan_type === 0 ? "Downgrade Plan" : "Upgrade Plan"}
            </button>
          ) : (
            <span className="mp-current">
              <i className="bx bx-badge-check"></i> Current Plan
            </span>
          )}
        </div>
      </motion.article>

      <MembershipUpgradeModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        currentPlan={currentPlan}
        newPlan={plan}
        planType={plan.plan_type === 0 ? 'downgrade' : 'upgrade'}
      />
    </>
  );
};

export default MembershipPlan;